// extracted by mini-css-extract-plugin
module.exports = {"item":"CategorizedItem-module--item--2Izw7"};